export default {
    rulesForAdd: {
        'root': {
            'site':true,
            'group':false,
            'building':true,
            'floor':false,
            'service':false,
            'plan':false,
        },
        'site': {
            'site':false,
            'group':true,
            'building':true,
            'floor':false,
            'service':false,
            'plan':false,
        },
        'group': {
            'site':false,
            'group':false,
            'building':true,
            'floor':false,
            'service':false,
            'plan':false,
        },
        'building': {
            'site':false,
            'group':false,
            'building':false,
            'floor':true,
            'service':true,
            'plan':true,
        },
        'floor': {
            'site':false,
            'group':false,
            'building':false,
            'floor':false,
            'service':true,
            'plan':true,
        },
        'service': {
            'site':false,
            'group':false,
            'building':false,
            'floor':false,
            'service':false,
            'plan':true,
        },
        'plan': {
            'site':false,
            'group':false,
            'building':false,
            'floor':false,
            'service':false,
            'plan':false,
        }
    },
    getRules: function(action,type){
        switch(action){
            case 'add':
                return this.rulesForAdd[this._transformType(type)];
                break;
        }

    },
    _transformType: function(type){
        return this.types[type];
    },
    types: {
        '1': 'root',
        '2': 'site',
        '3': 'group',
        '4': 'building',
        '5': 'floor',
        '6': 'service',
        '7': 'plan',
    }
}
